import React, { FC } from "react";
import { RightOutlined } from "@ant-design/icons";
import "../../pages/home/homeSeriesContent.scss";

export interface HomeSeriesPaginationProps {
  page: number;
  pageCount: number;
  hasPrev: boolean;
  hasNext: boolean;
  onPagePrev: () => void;
  onPageNext: () => void;
  /** Appended to root `div.home-series__pagination` */
  className?: string;
}

/**
 * 与剧集首页 `HomeSeriesContent` 底部分页相同的 DOM 与样式（`home-series__pagination` → `home-series__pager` + `home-series__page-info`）。
 */
export const HomeSeriesPagination: FC<HomeSeriesPaginationProps> = ({
  page,
  pageCount,
  hasPrev,
  hasNext,
  onPagePrev,
  onPageNext,
  className,
}) => {
  const rootClass = ["home-series__pagination", className].filter(Boolean).join(" ");
  return (
    <div className={rootClass}>
      <div className="home-series__pager">
        <button
          type="button"
          className="home-series__page-btn"
          onClick={onPagePrev}
          disabled={!hasPrev}
          aria-label="上一页"
        >
          <RightOutlined rotate={180} />
        </button>
        <button type="button" className="home-series__page-btn home-series__page-btn--active" disabled>
          {page}
        </button>
        <button
          type="button"
          className="home-series__page-btn"
          onClick={onPageNext}
          disabled={!hasNext}
          aria-label="下一页"
        >
          <RightOutlined />
        </button>
      </div>
      <span className="home-series__page-info">共 {pageCount} 页</span>
    </div>
  );
};
